import axios from "axios";
// Register with API
export let registerUser = async (userName,userEmail,userPassword,userConfPassword,languageId) => {

  try {
    const url = process.env.REACT_APP_ADMIN_API_URL + `/register`;
    let data = "";
    let qs = require('qs');

    data = qs.stringify({
      'name': userName,
      'email': userEmail,
      'password': userPassword,
      'password_confirmation': userConfPassword,
      'language_id': languageId
    });
    const response = await axios.post(
      url,
      data
    );
    return response.data
  } catch (error) {
    throw error;
  }
};